import React, { useState, useEffect, useRef } from "react";
import './product_sstyle.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'aos/dist/aos.css';
import banner from '../img/logo/banner-bg.png';
import amogh from '../img/logo/amogh.png'
import top from '../img/logo/left_top.png';
import bottom from '../img/logo/left_bottom.png';
import right_top from '../img/logo/right_top.png';
import right_bottom from '../img/logo/right_bottom.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FiMail, FiPhone } from "react-icons/fi";
import 'react-medium-image-zoom/dist/styles.css';
import intro from "../img/products/speaklear_intro.gif";
import video_intro from "../img/products/video_intro.mp4";
import impo from "../img/products/impo.svg";
import usericon from "../img/products/user.svg";
import mobileicon from "../img/products/mobile.svg";
import emailicon from "../img/products/email.svg";
import dobicon from "../img/products/dob.svg";
import Footer from "./Footer";
import { IoLogoGooglePlaystore } from "react-icons/io5";
import { IoIosAppstore } from "react-icons/io";
import Productdetails from "./Productdetails";

function Products() {
  const [formData, setFormData] = useState({ name: "", email: "", mobile: "" });
  const [errors, setErrors] = useState({});
  const [isYesChecked, setIsYesChecked] = useState(false);
  const [showsuccessAlert, setShowsuccessAlert] = useState(false);
  const [showfailureAlert, setShowfailureAlert] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // New state
  const [isChecked, setIsChecked] = useState(false);
  const videoRef = useRef(null);
  const nextSectionRef = useRef(null);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validateMobile = (mobile) => /^\d{10}$/.test(mobile);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  
    let newErrors = { ...errors };
  
    if (name === "email") {
      if (!validateEmail(value)) {
        newErrors.email = "Invalid email format";
      } else {
        delete newErrors.email; // Remove error if valid
      }
    }
  
    if (name === "mobile") {
      if (!validateMobile(value)) {
        newErrors.mobile = "Mobile number must be 10 digits";
      } else {
        delete newErrors.mobile; // Remove error if valid
      }
    }
  
    setErrors(newErrors);
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Validate form before submission
    let newErrors = {};
    if (!validateEmail(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!validateMobile(formData.mobile)) {
      newErrors.mobile = "Mobile number must be 10 digits";
    }
  
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return; // Stop submission if errors exist
    }
  
    setIsSubmitting(true);
    try {
      const response = await fetch("https://ableproindia.com/backend/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
  
      if (response.ok) {
        setShowsuccessAlert(true);
        setErrors({});
        setFormData({ name: "", email: "", mobile: "" });
  
        setTimeout(() => setShowsuccessAlert(false), 5000);
      } else {
        setShowfailureAlert(true);
        setTimeout(() => setShowfailureAlert(false), 5000);
      }
    } catch (error) {
      setShowfailureAlert(true);
      setTimeout(() => setShowfailureAlert(false), 5000);
    } finally {
      setIsSubmitting(false);
    }
  };


  const scrollToNextSection = () => {
    nextSectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleRadioChange = (e) => {
    setIsYesChecked(e.target.value === "yes");
    if (e.target.value === "no") {
      setShowfailureAlert(true);
    }
  };

  const handlehidefailuremsg = () => {
    setShowfailureAlert(false);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      //alert(observer);
      (entries) => {
        entries.forEach((entry) => {
          console.log(observer);
          if (entry.isIntersecting) {
            //alert('hi');
            videoRef.current?.play(); // Play video when in view
          }
        });
      },
      { threshold: 0.5 } // Play when at least 50% of video is visible
    );

    if (videoRef.current) {
    //alert(videoRef.current);
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, []);


  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    setIsYesChecked(false);
  };

  return (
<>
{/* <!-- ======= Start Home Section ======= --> */}

<section id="Home" className="product-home-bg section_class" style={{backgroundColor: '#3766d8'}}> 
{/* <video width="100%" autoPlay muted playsInline webkit-playsinline="true" className="video"> */}
<video ref={videoRef} width="100%" autoPlay muted playsInline webkit-playsinline="true" className="video" onEnded={scrollToNextSection}>
    <source src={video_intro} type="video/mp4"/>
  </video>
{/* <img src={intro} alt="Speaklear" width="100%" /> */}
{/* <iframe  width="100%" height="700" src="https://embed.figma.com/proto/Arh8lKO5ACQw2zUwSnjhCu/ABLEPRO-SOLUTIONS?node-id=244-33&p=f&scaling=scale-down-width&content-scaling=fixed&page-id=18%3A2&starting-point-node-id=241%3A5&embed-host=share&hide-ui=1" allowfullscreen></iframe> */}
</section>

{/* <section style={{ backgroundColor: '#F2F8FF', padding: '2%' }}>
  <iframe
    src="https://www.figma.com/proto/GlFKtoAFwovWlLURZhWpv3/Speaklear-Public-Platform?node-id=1-545&t=EofzG4UeUhibdLwa-1&embed-host=share&hide-ui=1"
    width="100%"
    height="700"
    style={{ border: 'none' }}
    allow="fullscreen"
    allowTransparency={true}
    title="FigmaFolio"
  />
</section> */}
<div ref={nextSectionRef}>
<Productdetails />
</div>
<section id="registration" className="product-home-register next-section section_class"  > 
<Container className="Containerd">
{/* <p className="para-text-livvic"><span className="high-user">Hello there,</span><br /><br />Speaklear™ application software is being developed as a speech practising and training platform especially for people with<span className="livvic_klear"> hearing and speech impairments.</span> <br /><br />By registering yourself on to this platform, you support us in developing a comprehensive speech database in refining our digital speech training models to yield better speech feedback, thereby helping us provide you better speech rehabilitation opportunities.<br /><br />We have put together a structured unit set for you or your child to record speech patterns. Please complete as much as you can and at your own convenience. 
(Kindly note, we are accepting speech recordings of people or children with atypical, impaired or non-standard speech only). <br /><br />
To learn more: <a href="">www.speaklear.com</a>
<br /><br />
</p> */}
<p className="para-text-livvic"><span className="high-user">Hello there,</span><br /><br /> By signing up to Speaklear™ platform,
you are voluntarily supporting us in building a comprehensive speech database in refining our digital speech training models to yield better speech feedback, thereby helping us provide better speech rehabilitation opportunities especially for people with hearing and speech impairments.<br /><br />
We have put together a structured unit set for you or your child to record your speech patterns. <br /><br />Tap on ‘I agree to participate’ to continue. </p>
<Row className="text-center d-flex mt-3">
  <Col xs={12} sm={6} md={4} lg={3} className="d-flex align-items-center">
    <input type="checkbox" id="customCheckbox" className="custom-checkbox me-2" checked={isChecked} onChange={handleCheckboxChange} />
    <label htmlFor="customCheckbox" className="checkbox-label para-text-livvic">I agree to participate.</label>
  </Col>
</Row>

{isChecked && (
  <Row >
    <Col xs={12} sm={12} md={{span:6, offset:3}} lg={{span:6, offset:3}}>
    <form onSubmit={handleSubmit} className="custom-form" >
    {/* <div className="input-container">
      <label>Do you or your child have a speech impairment or a speech disorder? <sup><img src={impo} /></sup></label>
      <p className="para-text-livvic">YES<input type="radio" value="yes" name="inform_us" onChange={handleRadioChange} /> NO<input type="radio" value="no" name="inform_us" onChange={handleRadioChange} /> </p>
      </div> */}

      <div className="input-container">
      <label>Is  this profile for you or for your child? <sup><img src={impo} /></sup></label>
      <p className="para-text-livvic">For me<input type="radio" value="for me" name="for_me" onChange={handleRadioChange} /> For my child<input type="radio" value="For my child" name="for_me" onChange={handleRadioChange} /> </p>
      </div>

    <div className="input-container">
      <label>Name *</label>
      <img src={usericon} className="input-icon" />
      <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Please enter your full name" title="Enter a valid name" required />
      </div>

      <div className="input-container">
      <label>Email *</label>
      <img src={emailicon} className="input-icon" />
      <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Please enter valid email id" title="Enter a valid email address" required />
      
      </div>
      {errors.email && <p className="error">{errors.email}</p>}

      <div className="input-container">
      <label>Date of birth *</label>
      <img src={dobicon} className="input-icon" />
      <input type="date" name="dob" value={formData.dob} placeholder="Please enter data of birth" title="Enter date of birth" onChange={handleChange} required />
      
      </div>
      {errors.dob && <p className="error">{errors.dob}</p>}


      <div className="input-container">
      <label>Mobile *</label>
      <img src={mobileicon} className="input-icon" />
      <input type="text" name="mobile" value={formData.mobile} minLength={10} maxLength={10} placeholder="Please enter valid 10 digit number" title="Enter a valid 10-digit mobile number" onChange={handleChange} required />
      
      </div>
      {errors.mobile && <p className="error">{errors.mobile}</p>}

      <div className="input-container">
      <label>Do you or someone in your household have a speech impairment or a speech disorder? <sup><img src={impo} /></sup></label>
      <p className="para-text-livvic">YES<input type="radio" value="yes" name="inform_us" onChange={handleRadioChange} /> NO<input type="radio" value="no" name="inform_us" onChange={handleRadioChange} /> </p>
      </div>

      <button type="submit" disabled={!isYesChecked} >Submit</button>
    </form>
    </Col>
</Row>
)}
<br />
{/* Custom Alert */}
    {showsuccessAlert && (
        <div className="custom-success-alert">
          <p className="para-text-livvic-center"><span className="high-text">Thank you! </span><br /><span className="high-normal">We acknowledge your registration. We will attend and revert back soon. Please expect an e-mail from us. </span></p>
        </div>
      )}

{showfailureAlert && (
        <div className="custom-failure-alert">
          <p className="para-text-livvic-center"><span className="high-text">Sorry! </span><br /><span className="high-normal">Registration is only for people with hearing and/or speech impairments at this time.<br />Kindly write an email to learn more at: <a href="mailto:support@ableproindia.com">support@ableproindia.com</a></span></p>
          <p align="center"><button className="ok_button" onClick={handlehidefailuremsg}>OK</button></p>
        </div>
      )}
</Container>
</section>
<section id="download_icons" style={{backgroundColor:'#F2F8FF'}} className="section_class text-white py-5 para-text-livvic"> 
  <div class="container text-center para-text-livvic-center">
    <h2 className="mb-3 para-text-livvic text-center">Get the App Now</h2>
    <p className="mb-4 para-text-livvic text-center">Download our app and start your journey today</p>
    
    <div className="d-flex justify-content-center gap-3 flex-wrap">
      <a href="https://play.google.com/store" target="_blank" className="btn btn-light d-flex align-items-center gap-2 px-4 py-2">
      <IoLogoGooglePlaystore />
        <div>
          <small className="d-block text-muted para-text-livvic">GET IT ON</small>
          <strong className="para-text-livvic">Google Play</strong>
        </div>
      </a>

      <a href="https://apps.apple.com/in/app/speaklear/id6743828335" target="_blank" class="btn btn-light d-flex align-items-center gap-2 px-4 py-2">
      <IoIosAppstore />
        <div>
          <small class="d-block text-muted para-text-livvic">GET IT ON</small>
          <strong className="para-text-livvic">App Store</strong>
        </div>
      </a>
    </div>
  </div>
</section>

<Footer></Footer>
  </>
  )
}

export default Products
